export default "/_next/static/chunks/fonts/Rubik-Bold-d6173c485abd77e07f4bd8342c35cbe6.ttf";